import React, { Dispatch, SetStateAction } from "react";
import {
  Utils, SanitizeOptions,
  ImmutableTree,Config
} from "@react-awesome-query-builder/ui";
import InterfaceSqlQueryBuilderState from "../interfaces/InterfaceSqlQueryBuilderState";

const stringify = JSON.stringify;
const preErrorStyle = { backgroundColor: "lightpink", margin: "10px", padding: "10px" };

export const validationTranslateOptions: Partial<SanitizeOptions> = {
    translateErrors: true,
    includeStringifiedItems: true,
    includeItemsPositions: true,
  };

export interface DemoQueryBuilderState {
  tree: ImmutableTree;
  initErrors: Array<string>;
  config: Config;
  skin: string;
  renderBocks: Record<string, boolean>;
  spelStr: string;
  sqlStr: string;
  spelErrors: Array<string>;
  sqlErrors: Array<string>;
  sqlWarnings: Array<string>;
  initFile: string;
}

export const defaultRenderBlocks: DemoQueryBuilderState["renderBocks"] = {
  validation: true,
  jsonlogic: true,
  elasticSearch: true,
  mongo: true,
  jsTree: true,
  spel: true,
  strings: true,
  sql: true,
  actions: false,
  withProfile: false,
  queryBuilder: true,
};

export const useValidation = (
  state: InterfaceSqlQueryBuilderState,
  setState: Dispatch<SetStateAction<InterfaceSqlQueryBuilderState>>,
  cardType: string,
  cardValue?:string
) => {
  const renderValidationBlock = () => {
    const {tree: immutableTree, config, renderBocks} = state;
    
    if (!renderBocks.validation) {
      return null;
    }

    if (cardType === 'QUERY') {
      const isValid = Utils.isValidTree(immutableTree, config);
      const validationRes = Utils.validateTree(immutableTree, config, {
        ...validationTranslateOptions,
      }).map(({
        errors, itemStr, itemPositionStr,
      }) => ({
        errors: errors.map(({
          side, delta, str, fixed
        }) => `${fixed ? "* " : ""}${side ? `[${[side, delta].filter(a => a != undefined).join(" ")}] ` : ""}${str!}`),
        itemStr,
        itemPositionStr,
      }));

      return (
        <>
          <hr/>
          {isValid ? null : <pre style={preErrorStyle}>{"Tree has errors"}</pre>}
          <div>
            Validation errors: 
            { validationRes.length > 0
              ? <pre style={preErrorStyle}>
                {stringify(validationRes, undefined, 2)}
              </pre>
              : "no"
            }
          </div>
        </>
      );
    } else if (cardType === 'FIELD') {
      // Field validation - check if field exists in config
      const fieldExists = cardValue?.trim() !== '';
      return (
        <>
          <hr/>
          {!fieldExists && <pre style={preErrorStyle}>{"Invalid field selected"}</pre>}
        </>
      );
    } else if (cardType === 'VALUE') {
      // Value validation - check if value is not empty
      const hasValue = cardValue?.trim() !== '';
      return (
        <>
          <hr/>
          {!hasValue && <pre style={preErrorStyle}>{"Value cannot be empty"}</pre>}
        </>
      );
    }

    return null;
  };

  return {
    renderValidationBlock,
  };
};
